import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useMutation } from "@tanstack/react-query";
import { ErrorResponse } from "@/common/types/errorResponse";
import { ClientUserBranchAccess } from "../types/clientUserBranchAccess.type";

interface UseDeleteCompanyBranchUserAccessesProps {
  userBranchAccess?: ClientUserBranchAccess;
  onSuccess?: () => void;
  onError?: (error: ErrorResponse) => void;
}

export const useDeleteCompanyBranchUserAccesses = ({ userBranchAccess, onSuccess, onError }: UseDeleteCompanyBranchUserAccessesProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['deleteCompanyBranchUserAccesses', userBranchAccess?.id],
    mutationFn: () => {
      const payload = {
        user_branch_accesses_attributes: [
          {
            id: userBranchAccess?.id,
            _destroy: true,
          }
        ]
      }

      return privateAxios.put(`/company_branches/${userBranchAccess?.branch.id}/update_user_accesses`, {
        company_branch: payload,
      });
    },
    onSuccess,
    onError,
  });
}
